<template>
  <nav class="groupbuy-nav">
    <router-link to="/group-buy" class="nav-item" active-class="active">
      <svg class="nav-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9 22V12H15V22" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>首页</span>
    </router-link>
    
    <router-link to="/my-group-buys" class="nav-item" active-class="active">
      <svg class="nav-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 11V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5 11H19L18 21H6L5 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <circle cx="12" cy="16" r="1" fill="currentColor"/>
      </svg>
      <span>我的团购</span>
    </router-link>
    
    <router-link to="/" class="nav-item" active-class="active">
      <svg class="nav-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>我的</span>
    </router-link>
  </nav>
</template>

<script>
export default {
  name: 'GroupBuyNav',
};
</script>

<style scoped>
.groupbuy-nav {
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: white;
  padding: 8px 0;
  border-top: 1px solid #f0f0f0;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  color: #999;
  text-decoration: none;
  padding: 4px 12px;
  transition: all 0.2s ease;
  flex: 1;
}

.nav-icon {
  width: 24px;
  height: 24px;
  margin-bottom: 3px;
  stroke: currentColor;
  transition: all 0.2s ease;
}

.nav-item:hover {
  color: #ff6b6b;
}

.nav-item.active {
  color: #ff6b6b;
}

.nav-item.active .nav-icon {
  stroke: #ff6b6b;
}
</style>
